import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import SellerServices from "../../services/SallerServices";
import UserServices from "../../services/UserServices";
import EventServices from "../../services/EventServices";
import EventCategoryServices from "../../services/EventCategoryServices";

function AddEvent() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        name: "",
        // category: "",
        vendorId: "",
        description: "",
        image: null,

        venue: "",
        address: "",

        state: "",
        stateName: "",

        city: "",
        cityName: "",

        startDate: "",
        startTime: "",

        endDate: "",
        endTime: "",

        totalCapacity: "",

        status: "Active",

        termsConditions: "",
    });
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [loadingVendors, setLoadingVendors] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "stateName") {
            const selectedState = stateList.find(
                (state) => state.name === value
            );

            setFormValues((prev) => ({
                ...prev,

                stateName: value,

                state: selectedState?._id || "",

                cityName: "",

                city: "",
            }));

            setCityList([]);

            if (selectedState?._id) {
                setLoadingCities(true);

                UserServices.getCities(selectedState._id)
                    .then((res) => {
                        console.log("Cities response:", res);

                        if (res?.status && res?.data) {
                            setCityList(res.data);
                        }
                    })
                    .catch((error) => {
                        console.error(
                            "Error fetching cities:",
                            error
                        );
                    })
                    .finally(() => {
                        setLoadingCities(false);
                    });
            }

            return;
        }

        // -------------------------
        // CITY CHANGE
        // -------------------------
        if (name === "cityName") {
            const selectedCity = cityList.find(
                (city) => city.name === value
            );

            setFormValues((prev) => ({
                ...prev,

                cityName: value,

                // API mein city ke andar NAME jayega
                city: selectedCity?.name || value,
            }));

            return;
        }

        // -------------------------
        // NORMAL INPUT
        // -------------------------
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        UserServices.getState()
            .then((res) => {
                console.log("States response:", res);

                if (res?.status && res?.data) {
                    setStateList(res.data);
                }
            })
            .catch((error) => {
                console.error(
                    "Error fetching states:",
                    error
                );
            });
    }, []);

    useEffect(() => {
        const fetchVendors = async () => {
            setLoadingVendors(true);

            try {
                const res = await UserServices.getAllVendor();

                console.log("Vendors response:", res);

                if (res?.status && res?.data) {
                    setVendorList(res.data);
                } else {
                    setVendorList([]);
                }
            } catch (error) {
                console.error("Error fetching vendors:", error);
                setVendorList([]);
            } finally {
                setLoadingVendors(false);
            }
        };

        fetchVendors();
    }, []);


    useEffect(() => {
        const fetchCategories = async () => {
            setLoadingCategories(true);

            try {
                const res = await EventCategoryServices.getActiveCategories();

                console.log("Active Categories response:", res);

                if (res?.status && res?.data) {
                    setCategoryList(res.data);
                } else {
                    setCategoryList([]);
                }
            } catch (error) {
                console.error("Error fetching event categories:", error);
                setCategoryList([]);
            } finally {
                setLoadingCategories(false);
            }
        };

        fetchCategories();
    }, []);
    // =====================================================
    // IMAGE CHANGE
    // =====================================================
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        setFormValues((prev) => ({
            ...prev,
            image: file,
        }));

        setImagePreview(URL.createObjectURL(file));
    };

    // =====================================================
    // VALIDATION
    // =====================================================
    const validateForm = () => {
        if (!formValues.name.trim()) {
            alert("Event name required");
            return false;
        }

        if (!formValues.description.trim()) {
            alert("Event description required");
            return false;
        }
    if (!formValues.vendorId) {
    alert("Vendor required");
    return false;
}
        if (!formValues.venue.trim()) {
            alert("Venue required");
            return false;
        }

        if (!formValues.address.trim()) {
            alert("Address required");
            return false;
        }

        if (!formValues.cityName.trim()) {
            alert("City required");
            return false;
        }

        if (!formValues.startDate) {
            alert("Start date required");
            return false;
        }

        if (!formValues.startTime) {
            alert("Start time required");
            return false;
        }

        if (!formValues.endTime) {
            alert("End time required");
            return false;
        }

        if (!formValues.totalCapacity) {
            alert("Total capacity required");
            return false;
        }

        if (!formValues.termsConditions.trim()) {
            alert("Terms & Conditions required");
            return false;
        }

        // --------------------------------------------
        // Since API has only ONE eventDate,
        // startDate will be sent as eventDate.
        // --------------------------------------------

        // const startDateTime = new Date(
        //     `${formValues.startDate}T${formValues.startTime}`
        // );

        // const endDateTime = new Date(
        //     `${formValues.endDate || formValues.startDate}T${formValues.endTime}`
        // );

        // if (endDateTime <= startDateTime) {
        //     alert(
        //         "End date/time must be after start date/time"
        //     );

        //     return false;
        // }

        return true;
    };

    // =====================================================
    // SUBMIT
    // =====================================================
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
            const formData = new FormData();

            // formData.append("categoryId", formValues.category);
            formData.append("vendorId", formValues.vendorId);
            formData.append("eventName", formValues.name);
            formData.append("eventDescription", formValues.description);
            formData.append("eventDate", formValues.startDate);
            formData.append("startTime",formValues.startTime);
            formData.append("endTime", formValues.endTime);
            formData.append("venue", formValues.venue);
            formData.append("address", formValues.address);
            formData.append("city", formValues.cityName);
            formData.append("totalCapacity", formValues.totalCapacity);
            formData.append("status", formValues.status);
            formData.append("termsConditions", formValues.termsConditions);

            if (formValues.image) {
                formData.append("image", formValues.image);
            }
            const res = await EventServices.createEvent(
                formData
            );

            console.log(
                "Create Event Response:",
                res
            );

            // =================================================
            // SUCCESS
            // =================================================
            if (res?.status) {
                alert(
                    res?.message ||
                    "Event created successfully"
                );

                navigate("/event-list");
            } else {
                alert(
                    res?.message ||
                    "Failed to create event"
                );
            }
        } catch (error) {
            console.error(
                "Create Event Error:",
                error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to create event"
            );
        } finally {
            setLoading(false);
        }
    };

    // =====================================================
    // CLEAN IMAGE PREVIEW
    // =====================================================
    useEffect(() => {
        return () => {
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }
        };
    }, [imagePreview]);

    return (
        <>
            <div className="right_col" role="main">

                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                            Add New Event
                        </h5>

                        <nav>
                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">
                                        Home
                                    </a>
                                </li>

                            </ol>
                        </nav>

                    </div>

                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">

                        <Link
                            className="list-banner-btn"
                            to="/event-list"
                        >
                            Event List
                        </Link>

                    </div>

                </div>

                <div className="container-box">

                    <div className="container-box-inner table-reponsive-tabe">

                        <div className="page-details">

                            <form onSubmit={handleSubmit}>

                                <div className="row">

                                    {/* =========================
                                        EVENT NAME
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Event Name
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter event name"
                                            />

                                        </div>

                                    </div>

                                    {/* <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Event Category
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="category"
                                                className="form-control"
                                                value={formValues.category}
                                                onChange={handleInputChange}
                                                disabled={loadingCategories}
                                            >
                                                <option value="">
                                                    {loadingCategories
                                                        ? "Loading Categories..."
                                                        : "Select Category"}
                                                </option>

                                                {categoryList.map((category) => (
                                                    <option
                                                        key={category._id}
                                                        value={category._id}
                                                    >
                                                        {category.categoryName}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>

                                    </div> */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>
                                                Vendor
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="vendorId"
                                                className="form-control"
                                                value={formValues.vendorId}
                                                onChange={handleInputChange}
                                                disabled={loadingVendors}
                                            >
                                                <option value="">
                                                    {loadingVendors
                                                        ? "Loading Vendors..."
                                                        : "Select Vendor"}
                                                </option>

                                                {vendorList.map((vendor) => (
                                                    <option
                                                        key={vendor._id}
                                                        value={vendor._id}
                                                    >
                                                        {vendor.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* =========================
                                        VENUE
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Venue
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                name="venue"
                                                className="form-control"
                                                value={formValues.venue}
                                                onChange={handleInputChange}
                                                placeholder="Enter venue"
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        STATE
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                State
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="stateName"
                                                className="form-control"
                                                value={formValues.stateName}
                                                onChange={handleInputChange}
                                            >

                                                <option value="">
                                                    Select State
                                                </option>

                                                {stateList.map((state) => (
                                                    <option
                                                        key={state._id}
                                                        value={state.name}
                                                    >
                                                        {state.name}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>

                                    </div>


                                    {/* =========================
                                        CITY
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                City
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="cityName"
                                                className="form-control"
                                                value={formValues.cityName}
                                                onChange={handleInputChange}
                                                disabled={
                                                    !formValues.state ||
                                                    loadingCities
                                                }
                                            >

                                                <option value="">
                                                    {loadingCities
                                                        ? "Loading cities..."
                                                        : "Select City"}
                                                </option>

                                                {cityList.map((city) => (
                                                    <option
                                                        key={city._id}
                                                        value={city.name}
                                                    >
                                                        {city.name}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>

                                    </div>


                                    {/* =========================
                                        ADDRESS
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Address
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                name="address"
                                                className="form-control"
                                                value={formValues.address}
                                                onChange={handleInputChange}
                                                placeholder="Enter event address"
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        START DATE
                                    ========================== */}
                                    <div className="col-lg-3 col-sm-6">

                                        <div className="input-field">

                                            <label>
                                                Start Date
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                name="startDate"
                                                className="form-control"
                                                value={formValues.startDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        START TIME
                                    ========================== */}
                                    <div className="col-lg-3 col-sm-6">

                                        <div className="input-field">

                                            <label>
                                                Start Time
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="time"
                                                name="startTime"
                                                className="form-control"
                                                value={formValues.startTime}
                                                onChange={handleInputChange}
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        END DATE
                                    ========================== */}
                                    <div className="col-lg-3 col-sm-6">

                                        <div className="input-field">

                                            <label>
                                                End Date
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        END TIME
                                    ========================== */}
                                    <div className="col-lg-3 col-sm-6">

                                        <div className="input-field">

                                            <label>
                                                End Time
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="time"
                                                name="endTime"
                                                className="form-control"
                                                value={formValues.endTime}
                                                onChange={handleInputChange}
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        TOTAL CAPACITY
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Total Capacity
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="number"
                                                name="totalCapacity"
                                                className="form-control"
                                                value={
                                                    formValues.totalCapacity
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="Enter total capacity"
                                                min="1"
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        STATUS
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Status
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="status"
                                                className="form-control"
                                                value={formValues.status}
                                                onChange={handleInputChange}
                                            >

                                                <option value="Active">
                                                    Active
                                                </option>

                                                <option value="Inactive">
                                                    Inactive
                                                </option>

                                            </select>

                                        </div>

                                    </div>


                                    {/* =========================
                                        EVENT IMAGE
                                    ========================== */}
                                    <div className="col-lg-6 col-sm-6">

                                        <div className="input-field">

                                            <label>
                                                Event Image
                                            </label>

                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={
                                                    handleImageChange
                                                }
                                            />

                                            {imagePreview && (
                                                <div
                                                    style={{
                                                        marginTop: "10px",
                                                    }}
                                                >

                                                    <img
                                                        src={imagePreview}
                                                        alt="Event Preview"
                                                        style={{
                                                            width: "150px",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border:
                                                                "1px solid #ccc",
                                                        }}
                                                    />

                                                </div>
                                            )}

                                        </div>

                                    </div>


                                    {/* =========================
                                        TERMS CONDITIONS
                                    ========================== */}
                                    <div className="col-lg-12 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Terms & Conditions
                                                <span className="red">*</span>
                                            </label>

                                            <textarea
                                                className="form-control video-desc"
                                                name="termsConditions"
                                                value={
                                                    formValues.termsConditions
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="Enter terms and conditions"
                                            />

                                        </div>

                                    </div>


                                    {/* =========================
                                        EVENT DESCRIPTION
                                    ========================== */}
                                    <div className="col-lg-12 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Event Description
                                                <span className="red">*</span>
                                            </label>

                                            <textarea
                                                className="form-control video-desc"
                                                name="description"
                                                value={
                                                    formValues.description
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="Enter event description"
                                            />

                                        </div>

                                    </div>

                                </div>


                                {/* =========================
                                    SUBMIT
                                ========================== */}
                                <div className="text-center mt-4">

                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{
                                            minWidth: "150px",
                                        }}
                                    >

                                        {loading
                                            ? "SUBMITTING..."
                                            : "SUBMIT"}

                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
}

export default AddEvent;